import { registerTldrawLibraryVersion } from "@tldraw/editor";
import {
  TldrawUiMenuActionCheckboxItem
} from "./lib/ui/components/primitives/menus/TldrawUiMenuActionCheckboxItem.mjs";
import {
  TldrawUiMenuActionItem
} from "./lib/ui/components/primitives/menus/TldrawUiMenuActionItem.mjs";
import {
  TldrawUiMenuToolItem
} from "./lib/ui/components/primitives/menus/TldrawUiMenuToolItem.mjs";
export * from "@tldraw/editor";
import { Tldraw } from "./lib/Tldraw.mjs";
import { TldrawImage } from "./lib/TldrawImage.mjs";
import { ArrowBindingUtil } from "./lib/bindings/arrow/ArrowBindingUtil.mjs";
import { TldrawHandles } from "./lib/canvas/TldrawHandles.mjs";
import { TldrawScribble } from "./lib/canvas/TldrawScribble.mjs";
import { TldrawSelectionBackground } from "./lib/canvas/TldrawSelectionBackground.mjs";
import { TldrawSelectionForeground } from "./lib/canvas/TldrawSelectionForeground.mjs";
import { TldrawShapeIndicators } from "./lib/canvas/TldrawShapeIndicators.mjs";
import { defaultBindingUtils } from "./lib/defaultBindingUtils.mjs";
import {
  DEFAULT_EMBED_DEFINITIONS,
  embedShapePermissionDefaults
} from "./lib/defaultEmbedDefinitions.mjs";
import {
  centerSelectionAroundPoint,
  getMediaAssetInfoPartial,
  createShapesForAssets,
  registerDefaultExternalContentHandlers
} from "./lib/defaultExternalContentHandlers.mjs";
import { defaultShapeTools } from "./lib/defaultShapeTools.mjs";
import { defaultShapeUtils } from "./lib/defaultShapeUtils.mjs";
import { registerDefaultSideEffects } from "./lib/defaultSideEffects.mjs";
import { defaultTools } from "./lib/defaultTools.mjs";
import { ArrowShapeTool } from "./lib/shapes/arrow/ArrowShapeTool.mjs";
import { ArrowShapeUtil } from "./lib/shapes/arrow/ArrowShapeUtil.mjs";
import {
  getArrowBindings,
  getArrowTerminalsInArrowSpace
} from "./lib/shapes/arrow/shared.mjs";
import { BookmarkShapeUtil } from "./lib/shapes/bookmark/BookmarkShapeUtil.mjs";
import { DrawShapeTool } from "./lib/shapes/draw/DrawShapeTool.mjs";
import { DrawShapeUtil } from "./lib/shapes/draw/DrawShapeUtil.mjs";
import { EmbedShapeUtil } from "./lib/shapes/embed/EmbedShapeUtil.mjs";
import { FrameShapeTool } from "./lib/shapes/frame/FrameShapeTool.mjs";
import { FrameShapeUtil } from "./lib/shapes/frame/FrameShapeUtil.mjs";
import { GeoShapeTool } from "./lib/shapes/geo/GeoShapeTool.mjs";
import { GeoShapeUtil } from "./lib/shapes/geo/GeoShapeUtil.mjs";
import { HighlightShapeTool } from "./lib/shapes/highlight/HighlightShapeTool.mjs";
import { HighlightShapeUtil } from "./lib/shapes/highlight/HighlightShapeUtil.mjs";
import { ImageShapeUtil } from "./lib/shapes/image/ImageShapeUtil.mjs";
import { LineShapeTool } from "./lib/shapes/line/LineShapeTool.mjs";
import { LineShapeUtil } from "./lib/shapes/line/LineShapeUtil.mjs";
import { NoteShapeTool } from "./lib/shapes/note/NoteShapeTool.mjs";
import { NoteShapeUtil } from "./lib/shapes/note/NoteShapeUtil.mjs";
import { TextLabel } from "./lib/shapes/shared/TextLabel.mjs";
import {
  FONT_FAMILIES,
  LABEL_FONT_SIZES,
  TEXT_PROPS
} from "./lib/shapes/shared/default-shape-constants.mjs";
import { useAsset } from "./lib/shapes/shared/useAsset.mjs";
import { useDefaultColorTheme } from "./lib/shapes/shared/useDefaultColorTheme.mjs";
import { useEditableText } from "./lib/shapes/shared/useEditableText.mjs";
import { TextShapeTool } from "./lib/shapes/text/TextShapeTool.mjs";
import { TextShapeUtil } from "./lib/shapes/text/TextShapeUtil.mjs";
import { VideoShapeUtil } from "./lib/shapes/video/VideoShapeUtil.mjs";
import { EraserTool } from "./lib/tools/EraserTool/EraserTool.mjs";
import { HandTool } from "./lib/tools/HandTool/HandTool.mjs";
import { LaserTool } from "./lib/tools/LaserTool/LaserTool.mjs";
import { SelectTool } from "./lib/tools/SelectTool/SelectTool.mjs";
import { getOccludedChildren, kickoutOccludedShapes } from "./lib/tools/SelectTool/selectHelpers.mjs";
import { ZoomTool } from "./lib/tools/ZoomTool/ZoomTool.mjs";
import { TldrawUi } from "./lib/ui/TldrawUi.mjs";
import {
  setDefaultUiAssetUrls
} from "./lib/ui/assetUrls.mjs";
import {
  DefaultActionsMenu
} from "./lib/ui/components/ActionsMenu/DefaultActionsMenu.mjs";
import {
  AlignMenuItems,
  DefaultActionsMenuContent,
  DistributeMenuItems,
  GroupOrUngroupMenuItem,
  ReorderMenuItems,
  RotateCWMenuItem,
  StackMenuItems,
  ZoomOrRotateMenuItem
} from "./lib/ui/components/ActionsMenu/DefaultActionsMenuContent.mjs";
import {
  DefaultContextMenu,
  DefaultContextMenu as DefaultContextMenu2
} from "./lib/ui/components/ContextMenu/DefaultContextMenu.mjs";
import { DefaultContextMenuContent } from "./lib/ui/components/ContextMenu/DefaultContextMenuContent.mjs";
import {
  DefaultDebugMenu
} from "./lib/ui/components/DebugMenu/DefaultDebugMenu.mjs";
import {
  DebugFlags,
  DefaultDebugMenuContent,
  ExampleDialog,
  FeatureFlags
} from "./lib/ui/components/DebugMenu/DefaultDebugMenuContent.mjs";
import { DefaultMenuPanel } from "./lib/ui/components/DefaultMenuPanel.mjs";
import {
  DefaultHelpMenu
} from "./lib/ui/components/HelpMenu/DefaultHelpMenu.mjs";
import {
  DefaultHelpMenuContent,
  KeyboardShortcutsMenuItem
} from "./lib/ui/components/HelpMenu/DefaultHelpMenuContent.mjs";
import {
  DefaultHelperButtons
} from "./lib/ui/components/HelperButtons/DefaultHelperButtons.mjs";
import { DefaultHelperButtonsContent } from "./lib/ui/components/HelperButtons/DefaultHelperButtonsContent.mjs";
import {
  DefaultKeyboardShortcutsDialog
} from "./lib/ui/components/KeyboardShortcutsDialog/DefaultKeyboardShortcutsDialog.mjs";
import { DefaultKeyboardShortcutsDialogContent } from "./lib/ui/components/KeyboardShortcutsDialog/DefaultKeyboardShortcutsDialogContent.mjs";
import { LanguageMenu } from "./lib/ui/components/LanguageMenu.mjs";
import {
  DefaultMainMenu
} from "./lib/ui/components/MainMenu/DefaultMainMenu.mjs";
import {
  DefaultMainMenuContent,
  EditSubmenu,
  ExportFileContentSubMenu,
  ExtrasGroup,
  MiscMenuGroup,
  PreferencesGroup,
  UndoRedoGroup,
  ViewSubmenu
} from "./lib/ui/components/MainMenu/DefaultMainMenuContent.mjs";
import { DefaultMinimap } from "./lib/ui/components/Minimap/DefaultMinimap.mjs";
import { MobileStylePanel } from "./lib/ui/components/MobileStylePanel.mjs";
import { DefaultNavigationPanel } from "./lib/ui/components/NavigationPanel/DefaultNavigationPanel.mjs";
import { OfflineIndicator } from "./lib/ui/components/OfflineIndicator/OfflineIndicator.mjs";
import { DefaultPageMenu } from "./lib/ui/components/PageMenu/DefaultPageMenu.mjs";
import { PageItemInput } from "./lib/ui/components/PageMenu/PageItemInput.mjs";
import {
  PageItemSubmenu
} from "./lib/ui/components/PageMenu/PageItemSubmenu.mjs";
import {
  DefaultQuickActions
} from "./lib/ui/components/QuickActions/DefaultQuickActions.mjs";
import { DefaultQuickActionsContent } from "./lib/ui/components/QuickActions/DefaultQuickActionsContent.mjs";
import { DefaultSharePanel } from "./lib/ui/components/SharePanel/DefaultSharePanel.mjs";
import { PeopleMenu } from "./lib/ui/components/SharePanel/PeopleMenu.mjs";
import { Spinner } from "./lib/ui/components/Spinner.mjs";
import {
  DefaultStylePanel
} from "./lib/ui/components/StylePanel/DefaultStylePanel.mjs";
import {
  ArrowheadStylePickerSet,
  CommonStylePickerSet,
  DefaultStylePanelContent,
  GeoStylePickerSet,
  OpacitySlider,
  SplineStylePickerSet,
  TextStylePickerSet
} from "./lib/ui/components/StylePanel/DefaultStylePanelContent.mjs";
import {
  DefaultToolbar
} from "./lib/ui/components/Toolbar/DefaultToolbar.mjs";
import {
  ArrowDownToolbarItem,
  ArrowLeftToolbarItem,
  ArrowRightToolbarItem,
  ArrowToolbarItem,
  ArrowUpToolbarItem,
  AssetToolbarItem,
  CheckBoxToolbarItem,
  CloudToolbarItem,
  DefaultToolbarContent,
  DiamondToolbarItem,
  DrawToolbarItem,
  EllipseToolbarItem,
  EraserToolbarItem,
  FrameToolbarItem,
  HandToolbarItem,
  HexagonToolbarItem,
  HighlightToolbarItem,
  LaserToolbarItem,
  LineToolbarItem,
  NoteToolbarItem,
  OvalToolbarItem,
  RectangleToolbarItem,
  RhombusToolbarItem,
  SelectToolbarItem,
  StarToolbarItem,
  TextToolbarItem,
  ToolbarItem,
  TrapezoidToolbarItem,
  TriangleToolbarItem,
  XBoxToolbarItem,
  useIsToolSelected
} from "./lib/ui/components/Toolbar/DefaultToolbarContent.mjs";
import {
  OverflowingToolbar
} from "./lib/ui/components/Toolbar/OverflowingToolbar.mjs";
import {
  CenteredTopPanelContainer
} from "./lib/ui/components/TopPanel/CenteredTopPanelContainer.mjs";
import { DefaultTopPanel } from "./lib/ui/components/TopPanel/DefaultTopPanel.mjs";
import {
  DefaultZoomMenu
} from "./lib/ui/components/ZoomMenu/DefaultZoomMenu.mjs";
import { DefaultZoomMenuContent } from "./lib/ui/components/ZoomMenu/DefaultZoomMenuContent.mjs";
import {
  ArrangeMenuSubmenu,
  ClipboardMenuGroup,
  ConversionsMenuGroup,
  ConvertToBookmarkMenuItem,
  ConvertToEmbedMenuItem,
  CopyAsMenuGroup,
  CopyMenuItem,
  CursorChatItem,
  CutMenuItem,
  DeleteMenuItem,
  DuplicateMenuItem,
  EditLinkMenuItem,
  EditMenuSubmenu,
  FitFrameToContentMenuItem,
  GroupMenuItem,
  MoveToPageMenu,
  PasteMenuItem,
  PrintItem,
  RemoveFrameMenuItem,
  ReorderMenuSubmenu,
  SelectAllMenuItem,
  ToggleAutoSizeMenuItem,
  ToggleDebugModeItem,
  ToggleEdgeScrollingItem,
  ToggleFocusModeItem,
  ToggleGridItem,
  ToggleLockMenuItem,
  ToggleReduceMotionItem,
  ToggleSnapModeItem,
  ToggleToolLockItem,
  ToggleTransparentBgMenuItem,
  ToggleWrapModeItem,
  UngroupMenuItem,
  UnlockAllMenuItem,
  ZoomTo100MenuItem,
  ZoomToFitMenuItem,
  ZoomToSelectionMenuItem
} from "./lib/ui/components/menu-items.mjs";
import {
  TldrawUiButton
} from "./lib/ui/components/primitives/Button/TldrawUiButton.mjs";
import {
  TldrawUiButtonCheck
} from "./lib/ui/components/primitives/Button/TldrawUiButtonCheck.mjs";
import {
  TldrawUiButtonIcon
} from "./lib/ui/components/primitives/Button/TldrawUiButtonIcon.mjs";
import {
  TldrawUiButtonLabel
} from "./lib/ui/components/primitives/Button/TldrawUiButtonLabel.mjs";
import {
  TldrawUiButtonPicker
} from "./lib/ui/components/primitives/TldrawUiButtonPicker.mjs";
import {
  TldrawUiDialogBody,
  TldrawUiDialogCloseButton,
  TldrawUiDialogFooter,
  TldrawUiDialogHeader,
  TldrawUiDialogTitle
} from "./lib/ui/components/primitives/TldrawUiDialog.mjs";
import {
  TldrawUiDropdownMenuCheckboxItem,
  TldrawUiDropdownMenuContent,
  TldrawUiDropdownMenuGroup,
  TldrawUiDropdownMenuIndicator,
  TldrawUiDropdownMenuItem,
  TldrawUiDropdownMenuRoot,
  TldrawUiDropdownMenuSub,
  TldrawUiDropdownMenuSubTrigger,
  TldrawUiDropdownMenuTrigger
} from "./lib/ui/components/primitives/TldrawUiDropdownMenu.mjs";
import { TldrawUiIcon } from "./lib/ui/components/primitives/TldrawUiIcon.mjs";
import { TldrawUiInput } from "./lib/ui/components/primitives/TldrawUiInput.mjs";
import { TldrawUiKbd } from "./lib/ui/components/primitives/TldrawUiKbd.mjs";
import {
  TldrawUiPopover,
  TldrawUiPopoverContent,
  TldrawUiPopoverTrigger
} from "./lib/ui/components/primitives/TldrawUiPopover.mjs";
import { TldrawUiSlider } from "./lib/ui/components/primitives/TldrawUiSlider.mjs";
import {
  TldrawUiMenuCheckboxItem
} from "./lib/ui/components/primitives/menus/TldrawUiMenuCheckboxItem.mjs";
import {
  TldrawUiMenuContextProvider
} from "./lib/ui/components/primitives/menus/TldrawUiMenuContext.mjs";
import {
  TldrawUiMenuGroup
} from "./lib/ui/components/primitives/menus/TldrawUiMenuGroup.mjs";
import {
  TldrawUiMenuItem
} from "./lib/ui/components/primitives/menus/TldrawUiMenuItem.mjs";
import {
  TldrawUiMenuSubmenu
} from "./lib/ui/components/primitives/menus/TldrawUiMenuSubmenu.mjs";
import { PORTRAIT_BREAKPOINT } from "./lib/ui/constants.mjs";
import {
  TldrawUiContextProvider
} from "./lib/ui/context/TldrawUiContextProvider.mjs";
import {
  unwrapLabel,
  useActions
} from "./lib/ui/context/actions.mjs";
import { AssetUrlsProvider, useAssetUrls } from "./lib/ui/context/asset-urls.mjs";
import {
  BreakPointProvider,
  useBreakpoint
} from "./lib/ui/context/breakpoints.mjs";
import {
  TldrawUiComponentsProvider,
  useTldrawUiComponents
} from "./lib/ui/context/components.mjs";
import {
  useDialogs
} from "./lib/ui/context/dialogs.mjs";
import {
  UiEventsProvider,
  useUiEvents
} from "./lib/ui/context/events.mjs";
import {
  useToasts
} from "./lib/ui/context/toasts.mjs";
import { useCanRedo, useCanUndo } from "./lib/ui/hooks/menu-hooks.mjs";
import { useMenuClipboardEvents, useNativeClipboardEvents } from "./lib/ui/hooks/useClipboardEvents.mjs";
import { useCopyAs } from "./lib/ui/hooks/useCopyAs.mjs";
import { useExportAs } from "./lib/ui/hooks/useExportAs.mjs";
import { useCollaborationStatus, useShowCollaborationUi } from "./lib/ui/hooks/useIsMultiplayer.mjs";
import { useKeyboardShortcuts } from "./lib/ui/hooks/useKeyboardShortcuts.mjs";
import { useLocalStorageState } from "./lib/ui/hooks/useLocalStorageState.mjs";
import { useMenuIsOpen } from "./lib/ui/hooks/useMenuIsOpen.mjs";
import { usePreloadAssets } from "./lib/ui/hooks/usePreloadAssets.mjs";
import { useReadonly } from "./lib/ui/hooks/useReadonly.mjs";
import { useRelevantStyles } from "./lib/ui/hooks/useRelevantStyles.mjs";
import {
  useTools
} from "./lib/ui/hooks/useTools.mjs";
import {
  useCurrentTranslation,
  useTranslation
} from "./lib/ui/hooks/useTranslation/useTranslation.mjs";
import { useDefaultHelpers } from "./lib/ui/overrides.mjs";
import { containBoxSize, downsizeImage } from "./lib/utils/assets/assets.mjs";
import { preloadFont } from "./lib/utils/assets/preload-font.mjs";
import { getEmbedInfo } from "./lib/utils/embeds/embeds.mjs";
import { copyAs } from "./lib/utils/export/copyAs.mjs";
import { exportToBlob, getSvgAsImage } from "./lib/utils/export/export.mjs";
import { exportAs } from "./lib/utils/export/exportAs.mjs";
import { fitFrameToContent, removeFrame } from "./lib/utils/frames/frames.mjs";
import {
  defaultEditorAssetUrls,
  setDefaultEditorAssetUrls
} from "./lib/utils/static-assets/assetUrls.mjs";
import { truncateStringWithEllipsis } from "./lib/utils/text/text.mjs";
import {
  TLV1AlignStyle,
  TLV1AssetType,
  TLV1ColorStyle,
  TLV1DashStyle,
  TLV1Decoration,
  TLV1FontStyle,
  TLV1ShapeType,
  TLV1SizeStyle,
  buildFromV1Document
} from "./lib/utils/tldr/buildFromV1Document.mjs";
import {
  TLDRAW_FILE_EXTENSION,
  parseAndLoadDocument,
  parseTldrawJsonFile,
  serializeTldrawJson,
  serializeTldrawJsonBlob
} from "./lib/utils/tldr/file.mjs";
registerTldrawLibraryVersion(
  "tldraw",
  "3.2.0",
  "esm"
);
export {
  AlignMenuItems,
  ArrangeMenuSubmenu,
  ArrowBindingUtil,
  ArrowDownToolbarItem,
  ArrowLeftToolbarItem,
  ArrowRightToolbarItem,
  ArrowShapeTool,
  ArrowShapeUtil,
  ArrowToolbarItem,
  ArrowUpToolbarItem,
  ArrowheadStylePickerSet,
  AssetToolbarItem,
  AssetUrlsProvider,
  BookmarkShapeUtil,
  BreakPointProvider,
  CenteredTopPanelContainer,
  CheckBoxToolbarItem,
  ClipboardMenuGroup,
  CloudToolbarItem,
  CommonStylePickerSet,
  DefaultContextMenu as ContextMenu,
  ConversionsMenuGroup,
  ConvertToBookmarkMenuItem,
  ConvertToEmbedMenuItem,
  CopyAsMenuGroup,
  CopyMenuItem,
  CursorChatItem,
  CutMenuItem,
  DEFAULT_EMBED_DEFINITIONS,
  DebugFlags,
  DefaultActionsMenu,
  DefaultActionsMenuContent,
  DefaultContextMenu2 as DefaultContextMenu,
  DefaultContextMenuContent,
  DefaultDebugMenu,
  DefaultDebugMenuContent,
  DefaultHelpMenu,
  DefaultHelpMenuContent,
  DefaultHelperButtons,
  DefaultHelperButtonsContent,
  DefaultKeyboardShortcutsDialog,
  DefaultKeyboardShortcutsDialogContent,
  DefaultMainMenu,
  DefaultMainMenuContent,
  DefaultMenuPanel,
  DefaultMinimap,
  DefaultNavigationPanel,
  DefaultPageMenu,
  DefaultQuickActions,
  DefaultQuickActionsContent,
  DefaultSharePanel,
  DefaultStylePanel,
  DefaultStylePanelContent,
  DefaultToolbar,
  DefaultToolbarContent,
  DefaultTopPanel,
  DefaultZoomMenu,
  DefaultZoomMenuContent,
  DeleteMenuItem,
  DiamondToolbarItem,
  DistributeMenuItems,
  DrawShapeTool,
  DrawShapeUtil,
  DrawToolbarItem,
  DuplicateMenuItem,
  EditLinkMenuItem,
  EditMenuSubmenu,
  EditSubmenu,
  EllipseToolbarItem,
  EmbedShapeUtil,
  EraserTool,
  EraserToolbarItem,
  ExampleDialog,
  ExportFileContentSubMenu,
  ExtrasGroup,
  FONT_FAMILIES,
  FeatureFlags,
  FitFrameToContentMenuItem,
  FrameShapeTool,
  FrameShapeUtil,
  FrameToolbarItem,
  GeoShapeTool,
  GeoShapeUtil,
  GeoStylePickerSet,
  GroupMenuItem,
  GroupOrUngroupMenuItem,
  HandTool,
  HandToolbarItem,
  HexagonToolbarItem,
  HighlightShapeTool,
  HighlightShapeUtil,
  HighlightToolbarItem,
  ImageShapeUtil,
  KeyboardShortcutsMenuItem,
  LABEL_FONT_SIZES,
  LanguageMenu,
  LaserTool,
  LaserToolbarItem,
  LineShapeTool,
  LineShapeUtil,
  LineToolbarItem,
  MiscMenuGroup,
  MobileStylePanel,
  MoveToPageMenu,
  NoteShapeTool,
  NoteShapeUtil,
  NoteToolbarItem,
  OfflineIndicator,
  OpacitySlider,
  OvalToolbarItem,
  OverflowingToolbar,
  PORTRAIT_BREAKPOINT,
  PageItemInput,
  PageItemSubmenu,
  PasteMenuItem,
  PeopleMenu,
  PreferencesGroup,
  PrintItem,
  RectangleToolbarItem,
  RemoveFrameMenuItem,
  ReorderMenuItems,
  ReorderMenuSubmenu,
  RhombusToolbarItem,
  RotateCWMenuItem,
  SelectAllMenuItem,
  SelectTool,
  SelectToolbarItem,
  Spinner,
  SplineStylePickerSet,
  StackMenuItems,
  StarToolbarItem,
  TEXT_PROPS,
  TLDRAW_FILE_EXTENSION,
  TLV1AlignStyle,
  TLV1AssetType,
  TLV1ColorStyle,
  TLV1DashStyle,
  TLV1Decoration,
  TLV1FontStyle,
  TLV1ShapeType,
  TLV1SizeStyle,
  TextLabel,
  TextShapeTool,
  TextShapeUtil,
  TextStylePickerSet,
  TextToolbarItem,
  Tldraw,
  TldrawHandles,
  TldrawImage,
  TldrawScribble,
  TldrawSelectionBackground,
  TldrawSelectionForeground,
  TldrawShapeIndicators,
  TldrawUi,
  TldrawUiButton,
  TldrawUiButtonCheck,
  TldrawUiButtonIcon,
  TldrawUiButtonLabel,
  TldrawUiButtonPicker,
  TldrawUiComponentsProvider,
  TldrawUiContextProvider,
  TldrawUiDialogBody,
  TldrawUiDialogCloseButton,
  TldrawUiDialogFooter,
  TldrawUiDialogHeader,
  TldrawUiDialogTitle,
  TldrawUiDropdownMenuCheckboxItem,
  TldrawUiDropdownMenuContent,
  TldrawUiDropdownMenuGroup,
  TldrawUiDropdownMenuIndicator,
  TldrawUiDropdownMenuItem,
  TldrawUiDropdownMenuRoot,
  TldrawUiDropdownMenuSub,
  TldrawUiDropdownMenuSubTrigger,
  TldrawUiDropdownMenuTrigger,
  TldrawUiIcon,
  TldrawUiInput,
  TldrawUiKbd,
  TldrawUiMenuActionCheckboxItem,
  TldrawUiMenuActionItem,
  TldrawUiMenuCheckboxItem,
  TldrawUiMenuContextProvider,
  TldrawUiMenuGroup,
  TldrawUiMenuItem,
  TldrawUiMenuSubmenu,
  TldrawUiMenuToolItem,
  TldrawUiPopover,
  TldrawUiPopoverContent,
  TldrawUiPopoverTrigger,
  TldrawUiSlider,
  ToggleAutoSizeMenuItem,
  ToggleDebugModeItem,
  ToggleEdgeScrollingItem,
  ToggleFocusModeItem,
  ToggleGridItem,
  ToggleLockMenuItem,
  ToggleReduceMotionItem,
  ToggleSnapModeItem,
  ToggleToolLockItem,
  ToggleTransparentBgMenuItem,
  ToggleWrapModeItem,
  ToolbarItem,
  TrapezoidToolbarItem,
  TriangleToolbarItem,
  UiEventsProvider,
  UndoRedoGroup,
  UngroupMenuItem,
  UnlockAllMenuItem,
  VideoShapeUtil,
  ViewSubmenu,
  XBoxToolbarItem,
  ZoomOrRotateMenuItem,
  ZoomTo100MenuItem,
  ZoomToFitMenuItem,
  ZoomToSelectionMenuItem,
  ZoomTool,
  buildFromV1Document,
  centerSelectionAroundPoint,
  containBoxSize,
  copyAs,
  getMediaAssetInfoPartial as createMediaAssetInfoSkeleton,
  createShapesForAssets,
  defaultBindingUtils,
  defaultEditorAssetUrls,
  defaultShapeTools,
  defaultShapeUtils,
  defaultTools,
  downsizeImage,
  embedShapePermissionDefaults,
  exportAs,
  exportToBlob,
  fitFrameToContent,
  getArrowBindings,
  getArrowTerminalsInArrowSpace,
  getEmbedInfo,
  getOccludedChildren,
  getSvgAsImage,
  kickoutOccludedShapes,
  parseAndLoadDocument,
  parseTldrawJsonFile,
  preloadFont,
  registerDefaultExternalContentHandlers,
  registerDefaultSideEffects,
  removeFrame,
  serializeTldrawJson,
  serializeTldrawJsonBlob,
  setDefaultEditorAssetUrls,
  setDefaultUiAssetUrls,
  truncateStringWithEllipsis,
  unwrapLabel,
  useActions,
  useAsset,
  useAssetUrls,
  useBreakpoint,
  useCanRedo,
  useCanUndo,
  useCollaborationStatus,
  useCopyAs,
  useCurrentTranslation,
  useDefaultColorTheme,
  useDefaultHelpers,
  useDialogs,
  useEditableText,
  useExportAs,
  useIsToolSelected,
  useKeyboardShortcuts,
  useLocalStorageState,
  useMenuClipboardEvents,
  useMenuIsOpen,
  useNativeClipboardEvents,
  usePreloadAssets,
  useReadonly,
  useRelevantStyles,
  useShowCollaborationUi,
  useTldrawUiComponents,
  useToasts,
  useTools,
  useTranslation,
  useUiEvents
};
//# sourceMappingURL=index.mjs.map
